import React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { FieldTable2 } from 'components/_basic/Form/FieldTable2';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import {
  GLOBAL_PERIOD_NAME,
  GLOBAL_PERIOD_TABLE_HEADINGS_NAME,
} from 'components/BusinessToolForm/Sections/Global/form';

import { getPeriodColumnsNames } from 'helpers/businessTool';
import { concatWithDot } from 'helpers/string';

import { ISolvencyFormTableProps } from './types';
import { solvencyFormPrefix } from '../../../utils/form';
import { SOLVENCY_FORM_NAMES } from '../../utils/form';

const FIRST_COLUMN_WIDTH = 165;

export const SolvencyFormTable: React.FC<ISolvencyFormTableProps> = ({ disabled = false }) => {
  const { control } = useFormContext();

  const period = useWatch({ name: GLOBAL_PERIOD_NAME });

  const tableName = concatWithDot(solvencyFormPrefix, SOLVENCY_FORM_NAMES.SOLVENCY_TABLE);
  const { fields } = useFieldArray({ control, name: tableName });

  const columnsNames = getPeriodColumnsNames(period);

  const variantsName = concatWithDot(solvencyFormPrefix, SOLVENCY_FORM_NAMES.SOLVENCY_VARIANTS, ':index');

  return (
    <FormSectionFilledCard>
      <FieldTable2
        rows={fields}
        name={tableName}
        disabled={disabled}
        columnsNames={columnsNames ?? []}
        firstColumnWidth={FIRST_COLUMN_WIDTH}
        watchRowTitleName={variantsName}
        headerName={GLOBAL_PERIOD_TABLE_HEADINGS_NAME}
        readOnly
      />
    </FormSectionFilledCard>
  );
};
